import React from 'react'
import './style.css'

export default class MapaContent extends React.Component{

    componentDidMount(){
        
        let i = document.querySelector('#image-zoom');
        let meter = document.querySelector('#zoom_control');
        let wrapper = document.querySelector('#map_inner_container')

        let zoom = 1;
        let drag = {
            x : 0,
            y : 0
        }

        let height = 561.009;
        let width = 796.3499999999999;

        let att = () =>{
            let cursor = zoom > 1 ? 'none' : 'initial';
            let transform = `
                scale(${zoom}) 
                translateX(${zoom > 1 ? 
                            -((drag.x - width / 2) * 0.45) * (1 + ((zoom - 1))) + 'px'
                            : '0px'}) 
                translateY(${zoom > 1 ? 
                            -((drag.y - height / 2) * 0.45) * (1 + ((zoom - 1))) + 'px'
                            : '0px'})
            `
            i.style = `cursor : ${cursor}; transform: ${transform}`

            meter.value = zoom;
        }

        i.addEventListener('mousemove', (e)=>{
            e.preventDefault()
            let max_factor = 0.7;
            let min_factor = 0.3;
            let tr = {
                x: e.offsetX,
                y: e.offsetY
            }
            if (tr.x > width * max_factor){
                tr.x = width * max_factor
            }
            if (tr.x < width * min_factor){
                tr.x = width * min_factor
            }

            if (tr.y > height * 0.9) {
                tr.y = height * 0.9
            }
            if (tr.y < height * 0.1) {
                tr.y = height * 0.1
            }
            drag = tr
            att()            
        })

        i.addEventListener('wheel', (e) =>{
            e.preventDefault()
            if (e.deltaY > 0)
                zoom = zoom > 1 ? zoom - 0.1 : 1                
            else
                zoom = zoom < 4 ? zoom + 0.1 : 4
            att()
        })

        meter.addEventListener('change', e=>{
            zoom = e.target.value;
            att()
        })

    }

/*     openDrawer = () => this.setState({isDrawerOpen : true})
    closeDrawer = () => this.setState({isDrawerOpen : false})
    toggleDrawer = () => this.setState({isDrawerOpen : !this.state.isDrawerOpen}) */

    render(){

        let {props} = this

        console.log(' MAPA VENDAS => this.props', props)

        let cores_ = props.mapaData.get('colors')
        let polys_ = props.mapaData.get('lotes path')
        let lotes_ = props.lotesData.toArray();
        let text_points_ = props.mapaData.get('text-points')
        let polys = null;
        let texts = null;

        let drawerOpen = false;

        const clickHandlerCreator = (loteN=0) => ()=>{
            console.log('const clickHandlerCreator = (loteN=0) => ()=>{', this.props.setLote)
            this.props.setLote(loteN)
        }

        if(polys_!=undefined && text_points_!=undefined) polys = polys_.map((obj,k)=>{
            let color = lotes_[k].disponibilidade == "Disponível"? cores_['Disponível'] : lotes_[k].disponibilidade == "Vendido"? cores_['Vendido'] : cores_['Em negociação'] ;
            return <g key={k}>
                        {/* <title> {`Lote ${k+1}, status : ${lotes_[k].disponibilidade}`} </title> */}
                        <path style={{fill:color}} d={obj}/>
                        {/* <text  
                            transform="matrix(0.99953949,0,0,0.99953949,-0.71034708,0.18141713)"
                            fontFamily="font-family: 'Work Sans', sans-serif;" x={text_points_[k].x} y={text_points_[k].y} key={k} fontSize={2}> {k+1} </text> */}
                    </g>
        })

        


        return(
            <div id='map_inner_container'>

                <input id='zoom_control' type='range' min='1' max='4' step='0.1'/>
                
                <svg 
                    viewBox = "0 0 796.35001 561.00898"
                    height = "561.009"
                    width = "796.3499999999999" 
                    id = "image-zoom" >

                        {polys}  

                </svg>


            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/administrativo/vendas/mapa/component.js